<section class="stacksBlockContainer" id="block-image" [ngClass]="getBlockFields(blockId).style?.layout == 'boxed' ? 'boxed' : ''">
  <div id="settingsTabs" *ngIf="checkSettings()">
    <a (click)="showDataTab()" [ngClass]="checkData() ? 'active' : ''">{{ 'Data' | translate }}</a>
    <a (click)="showStyleTab()" [ngClass]="checkStyle() ? 'active' : ''">{{ 'Style' | translate }}</a>
  </div>
  <!-- Sidebar -->
  <div *ngIf="checkSidebar()" class="blockSidebar" (click)="appendBlock($event)">
    <img src="assets/icons/image.svg" alt="" [ngClass]="builderService.getTour() ? 'glowingBlueElement' : ''" />
    <p>{{ 'Image' | translate }}</p>
  </div>
  <!-- Mobile Preview -->
  <div class="previewImage previewMobile" [ngStyle]="{
       'justify-content': getBlockFields(blockId).style?.align || 'center'
     }" *ngIf="checkPreview()" id="{{ 'blockid' + blockId }}" cdkDrag [cdkDragData]="blockId">
    <div class="blockControlHandlers" *ngIf="!builderService.globals">
      <div class="editBlock blockActionBtn" (click)="showData(blockId)">
        <mat-icon>edit</mat-icon>
      </div>
      <div class="blockHandle blockActionBtn" cdkDragHandle>
        <mat-icon [ngClass]="builderService.getTour() ? 'glowingRedElement' : ''">open_with</mat-icon>
      </div>
      <div class="deleteBlock blockActionBtn" (click)="deleteBlock(blockId)">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="blockPlaceholder" *cdkDragPlaceholder></div>
    <!-- Mobile Builder Content -->
    <img *ngIf="builderType === 'mobile'" [ngStyle]="getBlockFields(blockId)?.style" src="{{ getBlockFields(blockId).data?.src }}" />
    <!-- Website Builder Content -->
    <img *ngIf="builderType === 'website'" [ngStyle]="getBlockFields(blockId)?.style" src="{{ getBlockFields(blockId).data?.src }}" />
  </div>
  <!-- Data and Style Tabs -->
  <div class="previewFields" *ngIf="checkData()">
    <ul>
      <li>
        <label class="fileUpload" for="image"
          >{{ 'Choose an Image' | translate }}
          <input type="file" id="image" (change)="this.processFile($event, '', 'logo', blockId)" />
        </label>
      </li>
    </ul>
    <img src="{{ getBlockFields(blockId).data?.src }}" />

    <h4 class="listTitle">{{ 'Linking' | translate }}</h4>
    <mat-divider></mat-divider>
    <button class="stacksBtn blue refetchData" (click)="refetchData()">
      <mat-icon class="material-icons material-icons-outlined">refresh</mat-icon>
      {{ 'Refetch Products & Categories' | translate }}
    </button>
    <mat-divider></mat-divider>
    <mat-progress-bar mode="indeterminate" *ngIf="builderService.showSettingsProgress"></mat-progress-bar>
    <ul>
      <li>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Link Type' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('linkType', blockId, $event, 'select')" value="{{ getBlockFields(blockId).data?.linkType }}">
            <mat-option value="home">
              {{ 'Home' | translate }}
            </mat-option>
            <mat-option value="products" *ngIf="!builderService.standalone">
              {{ 'Products' | translate }}
            </mat-option>
            <mat-option value="allProductsCategories">
              {{ 'All Products Categories' | translate }}
            </mat-option>
            <mat-option value="products">
              {{ 'Products' | translate }}
            </mat-option>
            <mat-option value="productsCategories">
              {{ 'Product Category' | translate }}
            </mat-option>
            <mat-option value="productsSubCategories">
              {{ 'Product Sub Category' | translate }}
            </mat-option>
            <mat-option value="vendorProduct" *ngIf="this.vendor.vendorsList.length > 0">
              {{'Vendor Products' | translate}}
            </mat-option>
            <mat-option value="vendorCat" *ngIf="this.vendor.vendorsList.length > 0">
              {{'Vendor Categories' | translate}}
            </mat-option>
            <mat-option value="posts" *ngIf="!builderService.standalone">
              {{ 'Posts' | translate }}
            </mat-option>
            <mat-option value="externalURL">
              {{ 'External URL' | translate }}
            </mat-option>
            <mat-option value="account">
              {{ 'Account Page' | translate }}
            </mat-option>
            <mat-option value="signup">
              {{ 'Signup / Signin' | translate }}
            </mat-option>
            <mat-option value="contact">
              {{ 'Contact Us' | translate }}
            </mat-option>
            <mat-option value="referral">
              {{ 'Referral' | translate }}
            </mat-option>
            <mat-option value="about">
              {{ 'About Us' | translate }}
            </mat-option>
            <mat-option value="orders">
              {{ 'Orders' | translate }}
            </mat-option>
            <mat-option value="cart">
              {{ 'Cart' | translate }}
            </mat-option>
            <mat-option value="terms">
              {{ 'Terms' | translate }}
            </mat-option>
            <ng-container *ngIf="builderType == 'website'">
              <mat-option *ngFor="let customView of builderService.getCustomViews()" [value]="customView.page_name">
              {{ customView.page_name }}
            </mat-option>
            </ng-container>
            <ng-container *ngIf="builderType == 'mobile'">
              <mat-option *ngFor="let customView of builderService.getCustomViews()" [value]="customView.view_name">
              {{ customView.view_name }}
            </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </li>
      <li *ngIf="getBlockFields(blockId).data?.linkType == 'products' && !builderService.standalone">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Product' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('product', blockId, $event, 'select')" [(value)]="getBlockFields(blockId).data.product">
            <mat-option *ngFor="let product of storedProducts" [value]="product.id">
              {{ product.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>
      <li *ngIf="getBlockFields(blockId).data?.linkType == 'products' && builderService.standalone">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Standalone Product' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('product', blockId, $event, 'select')" [(value)]="getBlockFields(blockId).data.product">
            <mat-option *ngFor="let product of standaloneProductsService.storedStandaloneProducts" [value]="product.Id || product.product_id">
              {{ product.productName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>
      <li *ngIf="getBlockFields(blockId).data?.linkType == 'productsCategories' && !builderService.standalone">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Product Category' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('categories', blockId, $event, 'select')" [(value)]="getBlockFields(blockId).data.categories">
            <mat-option *ngFor="let productCategory of categoriesService.storedCategories" [value]="productCategory.id">
              {{ productCategory.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>

      <li *ngIf="getBlockFields(blockId).data?.linkType == 'productsCategories' || (getBlockFields(blockId).data?.linkType == 'productsSubCategories' && builderService.standalone)">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Product Category' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('categories', blockId, $event, 'select'); getCat($event)" [(value)]="getBlockFields(blockId).data.categories">
            <mat-option *ngFor="let productCategory of standaloneCategoriesService.storedStandaloneCategories" [value]="productCategory.id">
              {{ productCategory.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>
      <li *ngIf="getBlockFields(blockId).data?.linkType == 'productsSubCategories' && builderService.standalone && this.standaloneCategoriesService.availableSubs?.length > 0">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Product Sub Category' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('subcategories', blockId, $event, 'select')" [(value)]="getBlockFields(blockId).data.subcategories">
            <mat-option *ngFor="let subCat of this.standaloneCategoriesService.availableSubs" [value]="subCat.subCategoryId">
              {{ subCat.subcategory }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>

      <li *ngIf="getBlockFields(blockId).data?.linkType == 'vendorProduct' && builderService.standalone">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Vendor Projects' | translate }}</mat-label>
          <mat-select (selectionChange)="getVendorProds($event.value)"
            [(value)]="getBlockFields(blockId).data.vendorProject">
            <mat-option *ngFor="let vendorProject of this.vendor.vendorsList" [value]="vendorProject.id">
              {{ vendorProject.id }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>


      <li *ngIf="getBlockFields(blockId).data?.vendorProject && getBlockFields(blockId).data?.linkType == 'vendorProduct' && builderService.standalone">
        <mat-form-field appearance="outline">
          <mat-label> {{ getBlockFields(blockId).data.vendorProject }} {{ 'Products' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('vendorProduct', blockId, $event, 'select')"
            [(value)]="getBlockFields(blockId).data.vendorProduct">
            <mat-option *ngFor="let vendorProduct of this.standaloneProductsService.storedVendorProducts" [value]="vendorProduct.id">
              {{ vendorProduct.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>

      <li *ngIf="getBlockFields(blockId).data?.linkType == 'vendorCat' && builderService.standalone">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Vendor Projects' | translate }}</mat-label>
          <mat-select (selectionChange)="getVendorCats($event.value)"
            [(value)]="getBlockFields(blockId).data.vendorProject">
            <mat-option *ngFor="let vendorProject of this.vendor.vendorsList" [value]="vendorProject.id">
              {{ vendorProject.id }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>

      <li *ngIf="getBlockFields(blockId).data?.vendorProject && getBlockFields(blockId).data?.linkType == 'vendorCat' && builderService.standalone">
        <mat-form-field appearance="outline">
          <mat-label>{{ getBlockFields(blockId).data.vendorProject }} {{ 'Categories' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('vendorCat', blockId, $event, 'select')"
            [(value)]="getBlockFields(blockId).data.vendorCat">
            <mat-option *ngFor="let vendorCat of this.standaloneCategoriesService.storedVendorCategories" [value]="vendorCat.id">
              {{ vendorCat.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>

      <li *ngIf="getBlockFields(blockId).data?.linkType == 'posts'">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Post' | translate }}</mat-label>
          <mat-select (selectionChange)="queryChange('post', blockId, $event, 'select')" [(value)]="getBlockFields(blockId).data.post">
            <mat-option *ngFor="let post of storedPosts" [value]="post.ID">
              {{ post.post_title }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>

      <!-- in App Browser Options to open -->
      <li *ngIf="getBlockFields(blockId).data?.linkType == 'externalURL'">
      <label class="externalOptions">
          <input
            type="radio"
            name="browseOption-{{blockId}}"
            value="browser"
            [checked]="!getBlockFields(blockId).data?.browseOption || getBlockFields(blockId).data?.browseOption === 'browser'"
            (change)="queryChange('browseOption', blockId, $event, 'text')"
          />
          {{ 'Browser' | translate}}
        </label>

          <label class="externalOptions">
            <input
              type="radio"
              name="browseOption-{{blockId}}"
              value="inApp"
              [checked]="getBlockFields(blockId).data?.browseOption === 'inApp'"
              (change)="queryChange('browseOption', blockId, $event, 'text')"
            />
            {{'In-app Browse' | translate}}
          </label>
        </li>

      <li *ngIf="getBlockFields(blockId).data?.linkType == 'externalURL'">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'External URL' | translate }}</mat-label>
          <input matInput value="{{ getBlockFields(blockId).data?.externalURL }}" (keyup)="queryChange('externalURL', blockId, $event, 'text')" />
        </mat-form-field>
      </li>
    </ul>
  </div>

  <div class="styleFields" *ngIf="checkStyle()">
    <ul>
      <li>
        <mat-label>{{ 'Layout' | translate }}</mat-label>
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="selectedLayout" (selectionChange)="onLayoutChange($event.value, blockId)">
            <mat-option value="full">{{ 'Full Width' | translate }}</mat-option>
            <mat-option value="boxed">{{ 'Boxed' | translate }}</mat-option>
            <mat-option value="custom">{{ 'Custom' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </li>

      <ng-container *ngIf="selectedLayout === 'custom'">
        <li>
          <mat-label>{{ 'Width' | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="number" [(ngModel)]="customWidth" (change)="styleChange('width', blockId, $event, 'slider')" />
            <span matSuffix>px</span>
          </mat-form-field>
        </li>

        <li>
          <mat-label>{{ 'Height' | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="number" [(ngModel)]="customHeight" (change)="styleChange('height', blockId, $event, 'slider')" />
            <span matSuffix>px</span>
          </mat-form-field>
        </li>
      </ng-container>
      <h4 class="listTitle">{{ 'Alignment' | translate }}</h4>
      <mat-divider></mat-divider>
      <ul>
        <li class="alignSelfControls">
          <mat-label>{{ 'Align Self' | translate }}</mat-label>
          <div class="alignSelfButtons">
            <button mat-icon-button class="alignBtn" [class.active]="getBlockFields(blockId).style && getBlockFields(blockId).style['align-self'] === 'flex-start'" (click)="styleChange('align', blockId, { value: 'flex-start' }, 'button')" matTooltip="Align Left">
              <mat-icon>align_horizontal_left</mat-icon>
            </button>

            <button mat-icon-button class="alignBtn" [class.active]="getBlockFields(blockId).style && getBlockFields(blockId).style['align-self'] === 'center'" (click)="styleChange('align', blockId, { value: 'center' }, 'button')" matTooltip="Align Center">
              <mat-icon>align_horizontal_center</mat-icon>
            </button>

            <button mat-icon-button class="alignBtn" [class.active]="getBlockFields(blockId).style && getBlockFields(blockId).style['align-self'] === 'flex-end'" (click)="styleChange('align', blockId, { value: 'flex-end' }, 'button')" matTooltip="Align Right">
              <mat-icon>align_horizontal_right</mat-icon>
            </button>

            <button mat-icon-button class="alignBtn" [class.active]="getBlockFields(blockId).style && getBlockFields(blockId).style['align-self'] === 'stretch'" (click)="styleChange('align', blockId, { value: 'stretch' }, 'button')" matTooltip="Stretch">
              <mat-icon>open_in_full</mat-icon>
            </button>
          </div>
        </li>
      </ul>
    </ul>
    <h4 class="listTitle">{{ 'Margins' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Margin Top' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style && getBlockFields(blockId).style['margin-top']?.slice(0, -2) }}" (change)="styleChange('margin-top', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Right' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style && getBlockFields(blockId).style['margin-right']?.slice(0, -2) }}" (change)="styleChange('margin-right', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Bottom' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style && getBlockFields(blockId).style['margin-bottom']?.slice(0, -2) }}" (change)="styleChange('margin-bottom', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Left' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style && getBlockFields(blockId).style['margin-left']?.slice(0, -2) }}" (change)="styleChange('margin-left', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>
    <h4 class="listTitle">{{ 'Paddings' | translate }}</h4>

    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Padding Top' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style && getBlockFields(blockId).style['padding-top']?.slice(0, -2) }}" (change)="styleChange('padding-top', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Right' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style &&  getBlockFields(blockId).style['padding-right']?.slice(0, -2) }}" (change)="styleChange('padding-right', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Bottom' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style && getBlockFields(blockId).style['padding-bottom']?.slice(0, -2) }}" (change)="styleChange('padding-bottom', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Left' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style && getBlockFields(blockId).style['padding-left']?.slice(0, -2) }}" (change)="styleChange('padding-left', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>
    <mat-divider></mat-divider>
  </div>
</section>
